import { Button as ButtonBase } from '@mui/material'
import React, { MouseEvent } from 'react'
import CircularProgress from '../Progress/CircularProgress'

interface ButtonProps {
    onClick: (e: MouseEvent<HTMLButtonElement>) => void,
    label?: string,
    labelIcon?: any,
    variant?: "outlined" | "contained" | "text"
    disabled?: boolean,
    isLoading?: boolean,
    icons?: any,
    link?: string,
    fullWidth?: boolean,
    type ?: 'button' | 'reset' | 'submit'
}

const Button = ({type = 'button', onClick, disabled, label, variant = "contained", isLoading, icons, labelIcon, link, fullWidth = false }: ButtonProps) => {
    return (
        <ButtonBase type={type}
            fullWidth={fullWidth}
            size="medium"
            variant={variant}
            disabled={disabled}
            endIcon={!isLoading && icons}
            onClick={onClick}
            href={link} >
            {label} {isLoading && <CircularProgress />}
            {!isLoading && labelIcon}
        </ButtonBase>
    )
}

export default Button